/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const charges = makeEntityScaffold(
  'SAGA.API.CHARGES',
  (client, userId, options = {}) =>
    client.subscription.getBillingHistory(userId, options).then(data => data.billing_history),
  { defaultKey: 1 }
);
